import { combineReducers } from 'redux'
import { ArchiveListState } from './archive.list.reducer'
import { ConfigState } from './config.init.reducer'
import { ContactState } from './contact.us.reducer'
import { ModalsState } from './modals.reducer'
import { PackagesState } from './packages.reducer'
import { ProgramViewState } from './program.view.reducer'
import { ProgramsConductorState } from './programs.conductor.reducer'
import { TvState } from './tv.reducer'
import { UserState } from './user.session.reducer'
import { PagesState } from './pages.init.reducer'
import { MessageModalsState } from './message.modal.reducer'
import { ProfileDataState } from './profile.data.reducer'
import { ReportState } from './report.problem.reducer'
import { SliderState } from './slider.reducer'

import { connectRouter } from 'connected-react-router'
import { HttpCacheState } from './http.cache.reducer'

export const createRootReducer = (history: any) =>
  combineReducers({
    router: connectRouter(history),
    ProgramsConductorState,
    ConfigState,
    ArchiveListState,
    ModalsState,
    UserState,
    ContactState,
    TvState,
    ProgramViewState,
    PackagesState,
    ReportState,
    HttpCacheState,
    PagesState,
    MessageModalsState,
    ProfileDataState,
    SliderState,
  })

